import { render, staticRenderFns } from "./Queens_Lab4_ReportSheet2.vue?vue&type=template&id=2bcc54ae&"
import script from "./Queens_Lab4_ReportSheet2.vue?vue&type=script&lang=ts&"
export * from "./Queens_Lab4_ReportSheet2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSelect,VSimpleTable,VTextarea})
